import { useCallback, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import { getTypologies } from '../../../../../../api/theHive/redeProto';
import { Typology } from '../../../../../../api/theHive/redeProto/types';
import useErrorMessage from '../../../../../../hooks/useErrorMessage';
import useSnackbar from '../../../../../../hooks/useSnackbar';
import { RedeProtoOutletContext } from '../../types';

interface UseTypologiesHook {
  typologies: Typology[];
  loading: boolean;
  error: boolean;
}

export default function useTypologies(): UseTypologiesHook {
  const [typologies, setTypologies] = useState<Typology[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();
  const { selectedNoticeId } = useOutletContext<RedeProtoOutletContext>();

  const getData = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await getTypologies(selectedNoticeId);
      if (response.detail.description) {
        throw new Error(response.detail.description);
      }
      if (!response.data) {
        throw new Error('Algo deu errado, tente novamente.');
      }
      setTypologies(response.data);
    } catch (requestError) {
      setError(true);
      handleSnackbar(getErrorMessage(requestError), true);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNoticeId]);

  useEffect(() => {
    getData();
  }, [getData]);

  return { typologies, loading, error };
}
